<template>
  <table-task :config="tableConfig" :manager="manager" />
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import type { TasksScreenManager } from '@/logic/TasksScreen'

import { TASK_TYPE_SALES } from '@/constants'

import TableTask from './TableTask.vue'
import TableHeadActionsBase from './TableHeadActionsBase.vue'
import TableHeadStatusBase from './TableHeadStatusBase.vue'
import TableHeadDataSales from './TableHeadDataSales.vue'
import TableRowBase from './TableRowBase.vue'

@Component({
  name: 'SalesTable',
  components: {
    TableTask,
  },
})
export default class SalesTable extends Vue {
  @Prop() manager!: TasksScreenManager

  protected tableConfig = {
    headers: [
      {
        component: TableHeadStatusBase,
        props: {
          manager: this.manager,
          type: TASK_TYPE_SALES,
        },
        width: '20%',
      },
      {
        component: TableHeadDataSales,
        props: {
          manager: this.manager,
        },
      },
      {
        component: TableHeadActionsBase,
        props: {
          manager: this.manager,
          type: TASK_TYPE_SALES,
        },
        width: '25%',
      },
    ],
    row: {
      component: TableRowBase,
      props: {
        manager: this.manager,
        type: TASK_TYPE_SALES,
      },
    },
  }
}
</script>
